import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store/reducers/rootReducer'
import { IClientsItem } from '../../../../modules/API/Defaults/models/customers'
import SearchBlockWithTitle from '../../../../main/second/mainbar/procedures/Q8/Layouts/SearchBlockWithTitle'
import SearchCustomers from '../../../../main/second/mainbar/forcasts/Supply/Components/SearchCustomers'
import { PalletDetailFormData } from '../hooks/useEntryPallets'

type Props = {
  formData: PalletDetailFormData
  onChange: (data: Partial<PalletDetailFormData>) => void
}

const PalletDetailForm = ({ formData, onChange }: Props) => {
  const clientList: IClientsItem[] = useSelector(
    (state: RootState) => state.defaults.clientList.list ?? []
  )

  return (
    <FormWrapper>
      <SearchBlockWithTitle title="לקוח">
        <SearchCustomers
          list={clientList}
          defaultID={formData.customerID}
          setCustomerID={(id: number) => onChange({ customerID: id })}
          required
        />
      </SearchBlockWithTitle>

      <FieldsGrid>
        <FieldBlock>
          <FieldLabel>מחיר ₪</FieldLabel>
          <NumericInput
            type="number"
            min={0}
            value={formData.salePrice}
            aria-label="מחיר"
            onChange={(e) => onChange({ salePrice: +e.target.value })}
          />
        </FieldBlock>

        <FieldBlock>
          <FieldLabel>משקל ק"ג</FieldLabel>
          <NumericInput
            type="number"
            min={0}
            value={formData.weightNeto}
            aria-label="משקל"
            onChange={(e) => onChange({ weightNeto: +e.target.value })}
          />
        </FieldBlock>

        <FieldBlock>
          <FieldLabel>כמות אריזות</FieldLabel>
          <NumericInput
            type="number"
            min={0}
            value={formData.quantity}
            aria-label="כמות"
            onChange={(e) => onChange({ quantity: +e.target.value })}
          />
        </FieldBlock>
      </FieldsGrid>

      <FieldBlock>
        <FieldLabel>הערה</FieldLabel>
        <RemarkInput
          value={formData.remarks}
          aria-label="הערה"
          placeholder="הכנס הערה..."
          onChange={(e) => onChange({ remarks: e.target.value })}
        />
      </FieldBlock>
    </FormWrapper>
  )
}

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
`

const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.8em;
  direction: rtl;
`

const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3em;
`

const FieldLabel = styled.label`
  font-size: 0.78rem;
  color: #297f76;
  font-weight: 600;
  text-align: right;
`

const RemarkInput = styled.textarea`
  width: 100%;
  min-height: 5em;
  border: 2px solid #eff3f4;
  border-radius: 16px;
  padding: 0.6em 0.8em;
  text-align: right;
  background: #eff3f4;
  font-size: 1em;
  color: #1e2d3d;
  outline: none;
  resize: vertical;
  font-family: inherit;
  direction: rtl;

  &:focus {
    border-color: #80e081;
  }
`

const NumericInput = styled.input`
  width: 100%;
  height: 2.8em;
  border: 2px solid #eff3f4;
  border-radius: 30px;
  padding: 0 0.8em;
  text-align: right;
  background: #eff3f4;
  font-size: 1em;
  color: #1e2d3d;
  outline: none;
  appearance: none;

  &:focus {
    border-color: #80e081;
  }
`

export default PalletDetailForm
